<template>
<div v-if="valid">
  <v-card flat class="rounded-lg" elevation="0">
    <v-card-title class="text-subtitle-1" style="text-transform: uppercase;">
      CheckIn Year End Party 2025
    </v-card-title>
    <v-card-text style="min-height: 300px;">
      <v-row>
        <v-col cols="12">
          <file-upload v-model="attachmentUrl" ></file-upload>
        </v-col>
        <v-col cols="12">
          <p class="font-weight-bold">Bạn hãy chọn những tấm hình check-in đẹp nhất nhé!!
          </p>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn :disabled="!attachmentUrl" dark color="green darken-2" @click="checkIn">Check-In</v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>

import {IsValid, checkIn, error500} from './api'
import FileUpload from '../../../components/FileUpload.vue';

export default {
  name: "yep2025",
  components:{
    FileUpload
  },
  data() {
    return {
      attachmentUrl: null,
      valid: false
    }
  },
  methods: {
    checkIn() {
      if(!this.attachmentUrl){
        alert("Khong co hinh")
        return
      }else {
        return checkIn({attachmentUrl: this.attachmentUrl }).finally(() => {
          this.attachmentUrl = ""
        })
      }
    }
  },
  mounted() {
    error500()
    // IsValid().then(r => {
    //   this.valid = true
    // }).catch(e => {
    //   console.log(e)
    //   window.replace("google.com")
    // })
  }
}
</script>